module.exports = __webpack_public_path__ + "img/20210828_214015.2cccadb9.jpg";